import { View } from "react-native";

import { AlertProps } from "./Alert.type";
import { Div, Icon, Paragraph } from "../../basic";
import { Button } from "../../common/button";

export function Alert({
  bodyClassNames,
  headerClassNames,
  containerClassNames,
  title,
  message,
  onPress,
  align = "right",
  icon,
}: AlertProps) {
  return (
    <View
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: align === "center" ? "center" : align === "left" ? "flex-start" : "flex-end",
      }}
    >
      <Div classNames={["bgNeutralLighterMain", "mr-{24}", "br-{8}"]}>
        <Button classNames={containerClassNames} onPress={onPress}>
          {icon ? <Icon {...icon} /> : null}
          <Div classNames={["flexColumn", "gap4"]}>
            {title ? <Paragraph classNames={headerClassNames}>{title}</Paragraph> : null}
            <Paragraph classNames={bodyClassNames}>{message}</Paragraph>
          </Div>
        </Button>
      </Div>
    </View>
  );
}
